import { StoreState } from '@root/types';
import { PARAMETERS } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const getSourcePageFrom = (state: StoreState) => {
  switch (state.page.type) {
    case 'LISTING':
      return PARAMETERS.listingPage;
    case 'LISTING_SHARE':
      return PARAMETERS.listingPage;
    case 'LISTING_SEARCH':
      return PARAMETERS.searchResultsPage;
    case 'BUILDING':
      return PARAMETERS.buildingPage;
    case 'LANDLORD':
      return PARAMETERS.landlordPage;
    case 'TOURBOOK':
      return PARAMETERS.tourbookPage;
    case 'MANAGE_TOURBOOKS':
      return PARAMETERS.manageTourbooksPage;
    default:
      return null;
  }
};

export const getListingAnalyticsFromSearchResults = (state: StoreState, listingId) => {
  return state?.listings?.searchResults[listingId]?.analyticsInformation;
};
